import "core-js/modules/es.array.join.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import { DealStageEnum, LeaseTypeEnum, RateTypeEnum, UseEnum } from "utils/Enums";

/**
 * Shape of enum objects that have a `values` map with entries containing `label`.
 * Used for safe label lookup when the key may come from the backend and be null, undefined, or unknown.
 */

/**
 * Shape of enum objects whose values may have an `abbreviation` (e.g. ExpenseTypeEnum).
 */

/**
 * Shape of enum objects whose values carry the fields needed to build dropdown options.
 */

/** A `{ value, label }` pair for a Select/Combobox built from an enum. */

/**
 * Builds Select/Combobox options from an enum's `values` map: skips the blank ("")
 * entry and orders by the enum's own `order`. Use for a static enum-backed dropdown;
 * to resolve a single stored value to its label, use getEnumLabel instead.
 */
export function enumToOptions(enumObj) {
  var _context, _context2, _context3;
  return _mapInstanceProperty(_context = _sortInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$values(_valuesInstanceProperty(enumObj))).call(_context3, function (e) {
    return typeof e.value === "string" && e.value !== "";
  })).call(_context2, function (a, b) {
    var _a$order, _b$order;
    return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) - ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0);
  })).call(_context, function (e) {
    var _e$label;
    return {
      value: e.value,
      label: (_e$label = e.label) !== null && _e$label !== void 0 ? _e$label : ""
    };
  });
}

/**
 * Returns the display label for an enum value. Use instead of Enum.values[key].label
 * when key may be null, undefined, or not present in the enum (e.g. from API).
 *
 * @param enumObj - Enum object with a `values` map (e.g. RateTypeEnum, LeaseTypeEnum)
 * @param key - The enum key (e.g. dealroom.displayRateType). May be null/undefined or unknown.
 * @param defaultLabel - Fallback when key is null, undefined, or not in the enum.
 */
export function getEnumLabel(enumObj, key, defaultLabel) {
  var _ref, _entry$label;
  if (key == null || key === "") {
    return defaultLabel !== null && defaultLabel !== void 0 ? defaultLabel : "";
  }
  var entry = _valuesInstanceProperty(enumObj)[key];
  return (_ref = (_entry$label = entry === null || entry === void 0 ? void 0 : entry.label) !== null && _entry$label !== void 0 ? _entry$label : defaultLabel) !== null && _ref !== void 0 ? _ref : "";
}

/**
 * Returns the abbreviation for an enum value. Use instead of Enum.values[key].abbreviation
 * when key may be null, undefined, or not present in the enum.
 *
 * @param enumObj - Enum object with a `values` map containing `abbreviation` (e.g. ExpenseTypeEnum)
 * @param key - The enum key. May be null/undefined or unknown.
 * @param defaultAbbrev - Fallback when key is null, undefined, or not in the enum.
 */
export function getEnumAbbreviation(enumObj, key, defaultAbbrev) {
  var _ref2, _entry$abbreviation;
  if (key == null || key === "") {
    return defaultAbbrev !== null && defaultAbbrev !== void 0 ? defaultAbbrev : "";
  }
  var entry = _valuesInstanceProperty(enumObj)[key];
  return (_ref2 = (_entry$abbreviation = entry === null || entry === void 0 ? void 0 : entry.abbreviation) !== null && _entry$abbreviation !== void 0 ? _entry$abbreviation : defaultAbbrev) !== null && _ref2 !== void 0 ? _ref2 : "";
}

/** Label for a `LeaseTypeEnum` value; defaults to `""` when the key is missing or unknown. */
export function getLeaseTypeLabel(leaseType, defaultLabel) {
  return getEnumLabel(LeaseTypeEnum, leaseType, defaultLabel);
}

/**
 * Label for a `DealStageEnum` value; defaults to `"—"` (em dash) when the key is missing
 * or unknown, for table/display consistency.
 */
export function getDealStageLabel(dealStage, defaultLabel) {
  return getEnumLabel(DealStageEnum, dealStage, defaultLabel !== null && defaultLabel !== void 0 ? defaultLabel : "—");
}

/**
 * Label for a `RateTypeEnum` value; defaults to `RateTypeEnum.SQFT_YR.label` ("sf/yr")
 * when the key is missing or unknown.
 */
export function getRateTypeLabel(displayRateType, defaultLabel) {
  var _ref3, _RateTypeEnum$SQFT_YR;
  return getEnumLabel(RateTypeEnum, displayRateType, (_ref3 = defaultLabel !== null && defaultLabel !== void 0 ? defaultLabel : (_RateTypeEnum$SQFT_YR = RateTypeEnum.SQFT_YR) === null || _RateTypeEnum$SQFT_YR === void 0 ? void 0 : _RateTypeEnum$SQFT_YR.label) !== null && _ref3 !== void 0 ? _ref3 : "sf/yr");
}

/**
 * Joined display for a `UseEnum`-valued list (e.g. `building.use`), e.g. "Office, Industrial".
 * Unknown/blank entries are dropped rather than rendered as empty strings; `"-"` when the
 * list is empty or missing.
 */
export function getUseDisplay(use) {
  var _context4;
  if (!use || !use.length) return "-";
  return _filterInstanceProperty(_context4 = _mapInstanceProperty(use).call(use, function (u) {
    return getEnumLabel(UseEnum, u);
  })).call(_context4, Boolean).join(", ");
}